'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../enums/accordion.js');
require('../enums/alert.js');
require('../enums/avatar.js');
require('../enums/breakpoints.js');
var button = require('../enums/button.js');
require('../enums/code-editor.js');
var colors = require('../enums/colors.js');
require('../enums/combobox.js');
require('../enums/date.js');
require('../enums/drag-and-drop.js');
require('../enums/dialog.js');
require('../enums/divider.js');
require('../enums/dropdown.js');
require('../enums/fieldset.js');
require('../enums/font-icon.js');
require('../enums/fonts.js');
require('../enums/headings.js');
require('../enums/input.js');
require('../enums/keys.js');
require('../enums/list.js');
require('../enums/listbox.js');
var loader = require('../enums/loader.js');
require('../enums/margin.js');
require('../enums/option.js');
require('../enums/pill.js');
require('../enums/placements.js');
require('../enums/popout.js');
require('../enums/privacy.js');
require('../enums/radio-group.js');
require('../enums/status.js');
require('../enums/switch.js');
require('../enums/table.js');
require('../enums/tooltip.js');
require('../enums/transitions.js');
require('../enums/widths.js');
var colors$1 = require('./colors.js');

const defaultLightShimmerLoader = {
    gradientDark: colors.BrandfolderHexColors.DirtyMarshmallow,
    gradientLight: colors.BrandfolderHexColors.Marshmallow
};
const blackLoader = {
    strokeFromColor: colors.BrandfolderHexColors.Black,
    strokeToColor: colors.BrandfolderHexColors.GrayDark,
    textColor: colors.BrandfolderHexColors.Black
};
const primaryDarkLoader = {
    strokeFromColor: colors$1.brandfolderColorPalette.primary[400],
    strokeToColor: colors$1.brandfolderColorPalette.primary[200],
    textColor: colors.BrandfolderHexColors.White
};
const primaryLightLoader = {
    strokeFromColor: colors$1.brandfolderColorPalette.primary[500],
    strokeToColor: colors$1.brandfolderColorPalette.primary[300],
    textColor: colors.BrandfolderHexColors.Black
};
const warningLoader = {
    strokeFromColor: colors.BrandfolderHexColors.WarningRed,
    strokeToColor: '#F41D38',
    textColor: colors.BrandfolderHexColors.Black
};
const grayLoader = {
    strokeFromColor: colors$1.brandfolderColorPalette.neutrals[400],
    strokeToColor: colors$1.brandfolderColorPalette.neutrals[300],
    textColor: colors$1.brandfolderColorPalette.neutrals[400]
};
const whiteLoader = {
    strokeFromColor: colors.BrandfolderHexColors.White,
    strokeToColor: colors.BrandfolderHexColors.GrayMedium,
    textColor: colors.BrandfolderHexColors.White
};
/**
 * Get `LoaderLooks` from `ButtonLooks`
 * @param look ButtonLooks
 * @returns LoaderLooks
 */ const getLoaderLookFromButtonLook = (look)=>{
    switch(look){
        case button.ButtonLooks.Default:
            {
                return loader.LoaderLooks.Primary;
            }
        case button.ButtonLooks.Primary:
            {
                return loader.LoaderLooks.Gray;
            }
        case button.ButtonLooks.Secondary:
            {
                return loader.LoaderLooks.Gray;
            }
        case button.ButtonLooks.Tertiary:
            {
                return loader.LoaderLooks.Gray;
            }
        case button.ButtonLooks.Warning:
            {
                return loader.LoaderLooks.Gray;
            }
        default:
            {
                return loader.LoaderLooks.White;
            }
    }
};

exports.blackLoader = blackLoader;
exports.defaultLightShimmerLoader = defaultLightShimmerLoader;
exports.getLoaderLookFromButtonLook = getLoaderLookFromButtonLook;
exports.grayLoader = grayLoader;
exports.primaryDarkLoader = primaryDarkLoader;
exports.primaryLightLoader = primaryLightLoader;
exports.warningLoader = warningLoader;
exports.whiteLoader = whiteLoader;
//# sourceMappingURL=loader.js.map
